import React, { useState, useEffect } from "react";
import moment from "moment";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Avatar } from "@mui/material";
import { stringAvatar } from "../../../../Utils/avatar";
import { useJobProvider } from "../../../../Providers/Client/Jobs";
import { roles } from "../../../../Utils/constants";
import { useInvoiceProvider } from "../../../../Providers/Client/invoice";

export default function JobInformation() {

  const [invoice, setInvoice] = useState();
  const [invoiceid, setInvoiceId] = useState()
  const { invoices, fetchInvoiceForUser } = useInvoiceProvider();
  const { id, jobid } = useParams()

  const [job, setJob] = useState({
    name: "",
    description: "",
    main_skill: [],
    start_date: "",
    location: "",
  });
  const { fetchJobDetails } = useJobProvider();
  useEffect(() => {
    console.log(jobid)
    fetchJobDetails(jobid).then(setJob);
  }, [jobid]);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname

  /// new 


  useEffect(() => {
    fetchInvoiceForUser();
  }, [jobid]);

  useEffect(() => {
    if (id) {
      setInvoiceId(id)
    }
    if ((id || invoiceid) && invoices.length > 0) {
      // Find the row that matches the 'id' prop
      const row = invoices.find((invoice) => invoice?.id === (invoiceid || id));
      if (row) {
        setInvoice({
          jobId: row.job_id,
          start: row.month,
          invoiceId: row.id,
          invoiceStatus: row.status,
          vendor: row.vendor,
        });
      }
    }
  }, [invoiceid, id, jobid, invoices])

  return (
    <div>
      <div>
        <div className="flex flex-col bg-white rounded-lg font-[Roboto] p-4 space-y-3">
          <span
            className="cursor-pointer mb-4"
            onClick={() => {
              navigate(from ? from : "/dashboard/invoicescard")
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
              />
            </svg>
          </span>
          <span className="flex flex-row text-gray-700">
            <span className="mr-2 font-medium">Title:</span>
            <span>{job?.name}</span>
          </span>
          <span className="flex flex-row text-gray-700">
            <span className="mr-2 font-medium">Description:</span>
            <span className="text-justify">{job?.description}</span>
          </span>
          <span className="flex flex-row text-gray-700">
            <span className="mr-2 font-medium">Skills:</span>
            <span className="space-x-3">
              {job?.main_skill?.map((skill) => {
                return (
                  <span className="text-justify text-sm py-0.5 px-1 text-[#139588] w-[83px] h-[25px] border-[1px] border-[#139588]">
                    {skill}
                  </span>
                );
              })}
              {!job?.main_skill && "No Skills Provided"}
            </span>
          </span>
          <span className="flex justify-between text-gray-700">
            <span className="font-medium">
              Location: <span className="font-normal">{job?.location}</span>
            </span>
            <span className="font-medium">
              Start Date:{" "}
              <span className="font-normal">
                {job?.start_date
                  ? moment
                    .utc(job.start_date, "YYYY-MM-DD")
                    .format("DD/MM/YYYY")
                  : null}
              </span>
            </span>
            <span />
          </span>
        </div>
        <div className="mt-4"></div>
      </div>
      <div className="flex flex-row space-x-8 mt-8">
        {invoice?.vendor && <div className="flex flex-row justify-between">
          <div className="flex flex-row font-medium items-center space-x-12">
            <div className="font-semibold">Vendor: </div>
            <div
              style={{
                background: "#FFFFFF",
                border: "1px solid #BDBDBD",
                borderRadius: "10px",
              }}
              className={`flex flex-row h-[50px] px-4 items-center gap-x-3 text-black`}
            >
              <Avatar
                onClick={() =>
                  window.open(`${window.location.origin}/${roles.vendor.toLowerCase()}/profile/` + invoice?.vendor?.id)
                }
                className="cursor-pointer"
                {...stringAvatar(
                  `${invoice?.vendor?.company ?? ""}`
                )}
                src={invoice?.vendor?.profilePhoto}
              />
              <span>
                {invoice?.vendor?.company}
              </span>
            </div>
          </div>
        </div>}

        <div className="flex flex-row font-medium items-center space-x-6">
          <div className="font-semibold">Consultant: </div>
          <div
            style={{
              border: "1px solid #BDBDBD",
              borderRadius: "10px",
            }}
            className={`flex flex-row text-white h-[50px] px-4 items-center gap-x-3 bg-[#2EBAA3]`}
          >
            <Avatar
              onClick={() =>
                window.open(`${window.location.origin}/${roles.consultant.toLowerCase()}/profile/` + job?.consultant?.id)
              }
              className="cursor-pointer"
              {...stringAvatar(
                `${job?.consultant?.firstName ?? ""} ${job?.owner?.lastName ?? ""
                }`
              )}
              src={job?.consultant?.profilePhoto}
            />
            <span>
              {job?.consultant?.firstName} {job?.consultant?.lastName}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
